module.exports = __webpack_public_path__ + "static/media/living-room-with-rug.1102bda8.jpg";